import React from "react";

const ResourcePlanning = () => {
  return (
    <svg
      width="116"
      height="116"
      viewBox="0 0 116 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M115.989 58.6702C115.331 91.074 58.0297 116 58.0297 116C58.0297 116 2.04612 92.9448 0.0702298 58.6702C-1.90566 24.3955 38.2708 -1.77381 62.6401 0.094082C87.0095 1.96197 116.648 26.2664 115.989 58.6702Z"
        fill="#FCF0ED"
      />
      <path
        d="M34.4062 78.5376H36.9135L36.293 74.4553H36.2912H36.2694L36.8806 73.334H34.4402L35.0502 74.4553H35.0272L34.4062 78.5376Z"
        fill="#F0623F"
      />
      <path
        d="M52.6211 31.0418C52.6211 33.8255 54.8776 36.082 57.6624 36.082C60.4483 36.082 62.7042 33.8255 62.7042 31.0418C62.7042 28.257 60.4483 26 57.6624 26C54.8776 25.9999 52.6211 28.257 52.6211 31.0418Z"
        fill="#F0623F"
      />
      <path
        d="M54.749 36.5586C52.1288 36.5586 50.0078 38.6801 50.0078 41.2959V43.5974H65.3233V41.2959C65.3233 38.6801 63.2001 36.5586 60.5843 36.5586H54.749ZM59.5439 42.7839H58.8439H56.4881H55.7886L54.7007 37.0749C54.8077 37.0678 54.9125 37.059 55.0234 37.059H60.3088C60.4195 37.059 60.5238 37.0678 60.6302 37.0749L59.5439 42.7839Z"
        fill="#F0623F"
      />
      <path
        d="M58.2565 38.9457L58.8424 42.7845H59.5424L60.6287 37.0754C60.5223 37.0684 60.418 37.0596 60.3073 37.0596H55.0218C54.911 37.0596 54.8062 37.0684 54.6992 37.0754L55.7871 42.7845H56.4866L57.0697 38.9457H57.0901L56.5168 37.8924H58.8106L58.2379 38.9457H58.2565Z"
        fill="white"
      />
      <path
        d="M56.4883 42.7837H58.8441L58.2582 38.945H58.2396L58.8123 37.8916H56.5185L57.0918 38.945H57.0715L56.4883 42.7837Z"
        fill="#F0623F"
      />
      <path
        d="M30.6133 66.5089C30.6133 69.2943 32.8714 71.5508 35.6574 71.5508C38.4411 71.5508 40.6976 69.2943 40.6976 66.5089C40.6976 63.7252 38.4411 61.4688 35.6574 61.4688C32.8714 61.4688 30.6133 63.7252 30.6133 66.5089Z"
        fill="#F0623F"
      />
      <path
        d="M32.7373 72.0273C30.1188 72.0273 28 74.1489 28 76.7664V79.0662H43.3143V76.7664C43.3143 74.1489 41.1927 72.0273 38.5747 72.0273H32.7373ZM37.535 78.251H36.8339H34.4781H33.7769L32.6912 72.5436C32.7982 72.5364 32.9046 72.5277 33.0132 72.5277H38.2998C38.4089 72.5277 38.5138 72.5365 38.6201 72.5436L37.535 78.251Z"
        fill="#F0623F"
      />
      <path
        d="M36.2547 74.4145L36.8379 78.2516H37.5391L38.6243 72.5442C38.5178 72.537 38.413 72.5283 38.3039 72.5283H33.0173C32.9087 72.5283 32.8023 72.5371 32.6953 72.5442L33.781 78.2516H34.4822L35.0648 74.4145H35.0868L34.5135 73.3611H36.8079L36.233 74.4145H36.2547Z"
        fill="white"
      />
      <path
        d="M75.3008 66.5089C75.3008 69.2943 77.5584 71.5508 80.3432 71.5508C83.1247 71.5508 85.3834 69.2943 85.3834 66.5089C85.3834 63.7252 83.1247 61.4688 80.3432 61.4688C77.5584 61.4688 75.3008 63.7252 75.3008 66.5089Z"
        fill="#F0623F"
      />
      <path
        d="M79.7499 74.4141H79.7489L79.1641 78.2511L79.7499 74.4141Z"
        fill="#F0623F"
      />
      <path
        d="M77.4232 72.0273C74.8068 72.0273 72.6836 74.1489 72.6836 76.7664V79.0662H88.0006V76.7664C88.0006 74.1489 85.878 72.0273 83.2599 72.0273H77.4232ZM82.2193 78.251H81.5198H79.1629H78.4639L77.3765 72.5436C77.4829 72.5364 77.5899 72.5277 77.698 72.5277H82.9845C83.0932 72.5277 83.2018 72.5365 83.3072 72.5436L82.2193 78.251Z"
        fill="#F0623F"
      />
      <path
        d="M79.7714 74.4137L79.1992 73.3604L79.7714 74.4137Z"
        fill="#F0623F"
      />
      <path
        d="M80.9345 74.4145L81.5183 78.2516H82.2178L83.3057 72.5442C83.2003 72.537 83.0917 72.5283 82.983 72.5283H77.6965C77.5885 72.5283 77.4814 72.5371 77.375 72.5442L78.4624 78.2516H79.1614L79.7462 74.4145H79.7472H79.7665L79.1943 73.3611H81.4881L80.9131 74.4145H80.9345Z"
        fill="white"
      />
      <path
        d="M79.7499 74.4137L79.1641 78.2508H81.521L80.9372 74.4137H80.9158L81.4908 73.3604H79.197L79.7692 74.4137H79.7499Z"
        fill="#F0623F"
      />
      <path
        d="M33.0102 54.5216C32.6832 55.349 33.3054 56.2476 34.1969 56.2476H34.2325C34.7483 56.2476 35.2156 55.9382 35.4055 55.4598C36.8484 51.8306 39.3863 48.7589 42.5957 46.6215L42.6017 49.0475C42.6023 49.7251 43.1531 50.2721 43.83 50.2721H43.8345C44.5104 50.2699 45.0585 49.7185 45.0585 49.0398L45.0448 44.1461C45.0425 43.1976 44.2684 42.4268 43.3199 42.4268H43.3144L38.4202 42.441C37.7425 42.4432 37.1951 42.9946 37.1962 43.6727C37.1989 44.3507 37.7492 44.8972 38.424 44.8972H38.4295L40.5724 44.8916C37.2115 47.2956 34.5583 50.6274 33.0102 54.5216Z"
        fill="#F0623F"
      />
      <path
        d="M74.6873 53.0465L74.6851 53.0482C74.5359 53.712 74.9517 54.3687 75.6157 54.5163L80.3909 55.5878C81.3147 55.7963 82.2386 55.212 82.4499 54.287V54.2831L83.5219 49.5084C83.6711 48.8462 83.2525 48.1896 82.592 48.0403C81.9326 47.8922 81.2753 48.3069 81.1261 48.9675V48.9692L80.6773 50.9678C78.5629 47.3639 75.4433 44.3936 71.6524 42.5036C70.8547 42.1048 69.9072 42.6512 69.832 43.5394L69.8288 43.5767C69.7854 44.0891 70.0548 44.5801 70.5151 44.81C74.0005 46.5509 76.8402 49.3269 78.699 52.6905L76.1539 52.1188C75.4917 51.9712 74.8366 52.386 74.6873 53.0465Z"
        fill="#F0623F"
      />
      <path
        d="M65.8671 85.943C66.7125 85.6599 66.9951 84.6026 66.419 83.9235L66.3938 83.8944C66.0613 83.5027 65.5236 83.3463 65.0364 83.5103C61.3399 84.7507 57.3667 84.8023 53.669 83.7429L55.7762 82.289C56.333 81.905 56.4757 81.1413 56.0911 80.5839L56.0895 80.5806C55.7054 80.0237 54.9395 79.8832 54.381 80.2673L50.3535 83.0472C49.5717 83.5849 49.3748 84.6596 49.9119 85.4426L49.914 85.4464L52.6917 89.4738C53.0779 90.0323 53.8416 90.1734 54.4001 89.7871C54.9591 89.4025 55.0985 88.6394 54.7172 88.082L54.7133 88.0786L53.5359 86.3719C57.5702 87.4095 61.8643 87.2904 65.8671 85.943Z"
        fill="#F0623F"
      />
    </svg>
  );
};

export default ResourcePlanning;
